// CEO Travel — static data layer (no backend required)
// Multi-bahasa: ID (default), EN, ZH. Dipakai lewat api.get("/packages?lang=xx")

const GALLERY = [
  "https://images.unsplash.com/photo-1559827260-dc66d52bef19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "https://images.unsplash.com/photo-1540541338287-41700207dee6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "https://images.unsplash.com/photo-1582719508461-905c673771fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
];

const EXCLUSIONS = {
  id: [
    "Tiket pesawat menuju Singapore / Malaysia",
    "Pengeluaran pribadi (laundry, telepon, mini bar)",
    "Tipping driver & tour guide (opsional)",
    "Asuransi perjalanan",
    "Pajak ferry & terminal fee (~SGD 6 / MYR 25)",
  ],
  en: [
    "Flights to Singapore / Malaysia",
    "Personal expenses (laundry, phone, mini bar)",
    "Tipping for driver & tour guide (optional)",
    "Travel insurance",
    "Ferry tax & terminal fee (~SGD 6 / MYR 25)",
  ],
  zh: [
    "前往新加坡／马来西亚的机票",
    "个人消费（洗衣、电话、迷你吧）",
    "司机与导游小费（自愿）",
    "旅游保险",
    "渡轮税与码头费（约 SGD 6 / MYR 25）",
  ],
};

const PACKAGES = [
  {
    id: "pkg-1day-sg",
    price_from: 1360000,
    price_original: 1515000,
    discount_percent: 10,
    departure_from: "Singapore",
    image_url: "/services/pkg-1day-sg.png",
    gallery: ["/services/pkg-1day-sg.png"],
    order: 1,
    t: {
      id: {
        title: "Batam 1 Day – Short Escape",
        subtitle: "From Singapore",
        duration: "1 Hari",
        badge: null,
        description: "One-day getaway dari Singapore ke Batam. Cocok untuk team-building, family day, atau healing singkat. Berangkat pagi dari HarbourFront, kembali sore hari dengan ferry yang sama. Sudah termasuk lunch, transport private AC, dan beach club pass.",
        inclusions: [
          "Ferry PP Singapore – Batam (HarbourFront ↔ Batam Centre)",
          "Transport private AC + driver/guide bilingual EN/中文",
          "1× Lunch Indonesia / Seafood option",
          "Coffee break specialty Indonesia",
          "Pink Beach Club ATAU Tiffany Sand Club + free drink",
          "Air mineral selama trip",
          "Welcome snack",
        ],
        itinerary: [
          { day: 1, title: "Singapore → Batam → Singapore", activities: [
            "07:00 – Berkumpul di HarbourFront Ferry Terminal",
            "08:00 – Ferry menuju Batam Centre (50 menit)",
            "09:30 – Pickup oleh driver, briefing & coffee break",
            "10:30 – City tour: Vihara Maitreya / Cheng Ho Mosque (foto stop)",
            "12:30 – Lunch seafood lokal",
            "14:00 – Pink Beach Club / Tiffany Sand Club + welcome drink",
            "16:30 – Shopping Kueh Lapis & oleh-oleh",
            "17:30 – Drop-off di Batam Centre Ferry Terminal",
            "18:30 – Ferry kembali ke Singapore HarbourFront",
          ]},
        ],
      },
      en: {
        title: "Batam 1 Day – Short Escape",
        subtitle: "From Singapore",
        duration: "1 Day",
        badge: null,
        description: "A one-day getaway from Singapore to Batam. Perfect for team-building, family day, or a quick escape. Depart in the morning from HarbourFront and return the same evening. Includes lunch, private AC transport, and a beach club pass.",
        inclusions: [
          "Return ferry Singapore – Batam (HarbourFront ↔ Batam Centre)",
          "Private AC transport + bilingual EN/Chinese driver-guide",
          "1× Lunch (Indonesian / seafood option)",
          "Indonesian specialty coffee break",
          "Pink Beach Club OR Tiffany Sand Club + free drink",
          "Mineral water throughout the trip",
          "Welcome snack",
        ],
        itinerary: [
          { day: 1, title: "Singapore → Batam → Singapore", activities: [
            "07:00 – Meet at HarbourFront Ferry Terminal",
            "08:00 – Ferry to Batam Centre (50 minutes)",
            "09:30 – Driver pickup, briefing & coffee break",
            "10:30 – City tour: Maitreya Temple / Cheng Ho Mosque (photo stop)",
            "12:30 – Local seafood lunch",
            "14:00 – Pink Beach Club / Tiffany Sand Club + welcome drink",
            "16:30 – Shopping for Kueh Lapis & souvenirs",
            "17:30 – Drop-off at Batam Centre Ferry Terminal",
            "18:30 – Ferry back to Singapore HarbourFront",
          ]},
        ],
      },
      zh: {
        title: "巴淡岛一日游 – Short Escape",
        subtitle: "从新加坡出发",
        duration: "1天",
        badge: null,
        description: "从新加坡出发的一日游。适合团建、家庭日或短途放松。早上从 HarbourFront 出发，当天傍晚乘同一渡轮返回。含午餐、私人空调车与海滩俱乐部入场。",
        inclusions: [
          "新加坡－巴淡岛往返渡轮（HarbourFront ↔ Batam Centre）",
          "私人空调车 + 中英双语司机兼导游",
          "1× 午餐（印尼菜／海鲜可选）",
          "印尼特色咖啡歇息",
          "Pink Beach Club 或 Tiffany Sand Club + 免费饮料",
          "全程矿泉水",
          "迎宾小食",
        ],
        itinerary: [
          { day: 1, title: "新加坡 → 巴淡岛 → 新加坡", activities: [
            "07:00 – 于 HarbourFront 渡轮码头集合",
            "08:00 – 乘渡轮前往 Batam Centre（约50分钟）",
            "09:30 – 司机接送、行程说明与咖啡歇息",
            "10:30 – 市区游览：弥勒佛寺／郑和清真寺（拍照停留）",
            "12:30 – 当地海鲜午餐",
            "14:00 – Pink Beach Club／Tiffany Sand Club + 迎宾饮料",
            "16:30 – 选购千层糕与手信",
            "17:30 – 送返 Batam Centre 渡轮码头",
            "18:30 – 乘渡轮返回新加坡 HarbourFront",
          ]},
        ],
      },
    },
  },
  {
    id: "pkg-2d1n-my",
    price_from: 1670000,
    price_original: 1999000,
    discount_percent: 16,
    departure_from: "Malaysia",
    image_url: "https://images.unsplash.com/photo-1582719508461-905c673771fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: GALLERY,
    order: 2,
    t: {
      id: {
        title: "Batam 2D1N – Leisure Escape",
        subtitle: "From Malaysia",
        duration: "2D1N",
        badge: "Diskon 16%",
        description: "Weekend escape dari Johor / Malaysia ke Batam. 2 hari penuh menjelajah ikon Batam — Barelang Bridge, beach club, kuil, dan kuliner seafood. Menginap 1 malam di hotel bintang 3 di Nagoya area.",
        inclusions: [
          "Ferry PP Malaysia (Stulang Laut) – Batam Centre",
          "Coach private AC selama 2 hari",
          "1 malam hotel bintang 3 di Nagoya area",
          "1× Breakfast hotel + 2× Lunch (Indonesia/Seafood/Chinese)",
          "Coffee break specialty Indonesia",
          "Pink Beach Club + Tiffany Sand Club",
          "Barelang Bridge, Vihara Maitreya, Cheng Ho, Pasar Aviari",
          "Driver/guide bilingual EN/中文/BM",
        ],
        itinerary: [
          { day: 1, title: "Malaysia → Batam · City Highlights", activities: [
            "08:00 – Berkumpul di Stulang Laut Ferry Terminal",
            "09:30 – Ferry menuju Batam Centre",
            "11:00 – Pickup & welcome coffee break",
            "12:30 – Lunch seafood di Sei Enam / Golden Prawn",
            "14:00 – Barelang Bridge & sunset photo stop",
            "16:30 – Vihara Maitreya (kuil terbesar SEA)",
            "18:30 – Check-in hotel di Nagoya",
            "19:30 – Dinner free & explore Nagoya Hills",
          ]},
          { day: 2, title: "Beach Club & Shopping", activities: [
            "07:00 – Breakfast di hotel",
            "09:00 – Check-out & menuju Pink Beach Club",
            "10:00 – Beach Club: berenang, kayak, welcome drink",
            "12:30 – Lunch Indonesia di Tiffany Sand Club",
            "14:30 – Coffee factory + tasting Kueh Lapis",
            "16:00 – Shopping batik & oleh-oleh di Top 100 / BCS Mall",
            "17:30 – Drop-off Batam Centre",
            "19:00 – Ferry kembali ke Malaysia",
          ]},
        ],
      },
      en: {
        title: "Batam 2D1N – Leisure Escape",
        subtitle: "From Malaysia",
        duration: "2D1N",
        badge: "16% Off",
        description: "A weekend escape from Johor / Malaysia to Batam. Two full days exploring Batam's icons — Barelang Bridge, beach clubs, temples, and seafood dining. One night at a 3-star hotel in the Nagoya area.",
        inclusions: [
          "Return ferry Malaysia (Stulang Laut) – Batam Centre",
          "Private AC coach for 2 days",
          "1 night at a 3-star hotel in Nagoya",
          "1× Hotel breakfast + 2× Lunch (Indonesian/seafood/Chinese)",
          "Indonesian specialty coffee break",
          "Pink Beach Club + Tiffany Sand Club",
          "Barelang Bridge, Maitreya Temple, Cheng Ho, Aviari Market",
          "Bilingual EN/Chinese/Malay driver-guide",
        ],
        itinerary: [
          { day: 1, title: "Malaysia → Batam · City Highlights", activities: [
            "08:00 – Meet at Stulang Laut Ferry Terminal",
            "09:30 – Ferry to Batam Centre",
            "11:00 – Pickup & welcome coffee break",
            "12:30 – Seafood lunch at Sei Enam / Golden Prawn",
            "14:00 – Barelang Bridge & sunset photo stop",
            "16:30 – Maitreya Temple (largest in Southeast Asia)",
            "18:30 – Hotel check-in in Nagoya",
            "19:30 – Free dinner & explore Nagoya Hills",
          ]},
          { day: 2, title: "Beach Club & Shopping", activities: [
            "07:00 – Breakfast at the hotel",
            "09:00 – Check-out & head to Pink Beach Club",
            "10:00 – Beach Club: swimming, kayaking, welcome drink",
            "12:30 – Indonesian lunch at Tiffany Sand Club",
            "14:30 – Coffee factory + Kueh Lapis tasting",
            "16:00 – Batik & souvenir shopping at Top 100 / BCS Mall",
            "17:30 – Drop-off at Batam Centre",
            "19:00 – Ferry back to Malaysia",
          ]},
        ],
      },
      zh: {
        title: "巴淡岛2天1夜 – Leisure Escape",
        subtitle: "从马来西亚出发",
        duration: "2天1夜",
        badge: "16% 折扣",
        description: "从柔佛／马来西亚出发的周末之旅。两天畅游巴淡岛地标——巴淡大桥、海滩俱乐部、寺庙与海鲜美食。入住 Nagoya 区三星级酒店一晚。",
        inclusions: [
          "马来西亚（Stulang Laut）－Batam Centre 往返渡轮",
          "两天私人空调巴士",
          "Nagoya 区三星级酒店住宿一晚",
          "1× 酒店早餐 + 2× 午餐（印尼／海鲜／中式）",
          "印尼特色咖啡歇息",
          "Pink Beach Club + Tiffany Sand Club",
          "巴淡大桥、弥勒佛寺、郑和清真寺、Aviari 市场",
          "中英马三语司机兼导游",
        ],
        itinerary: [
          { day: 1, title: "马来西亚 → 巴淡岛 · 城市精华", activities: [
            "08:00 – 于 Stulang Laut 渡轮码头集合",
            "09:30 – 乘渡轮前往 Batam Centre",
            "11:00 – 接送与迎宾咖啡歇息",
            "12:30 – 于 Sei Enam／Golden Prawn 享用海鲜午餐",
            "14:00 – 巴淡大桥与日落拍照停留",
            "16:30 – 弥勒佛寺（东南亚最大）",
            "18:30 – 入住 Nagoya 区酒店",
            "19:30 – 自由晚餐，畅游 Nagoya Hills",
          ]},
          { day: 2, title: "海滩俱乐部与购物", activities: [
            "07:00 – 酒店早餐",
            "09:00 – 退房前往 Pink Beach Club",
            "10:00 – 海滩俱乐部：游泳、皮划艇、迎宾饮料",
            "12:30 – 于 Tiffany Sand Club 享用印尼午餐",
            "14:30 – 咖啡工厂 + 千层糕试吃",
            "16:00 – 于 Top 100／BCS Mall 选购蜡染与手信",
            "17:30 – 送返 Batam Centre",
            "19:00 – 乘渡轮返回马来西亚",
          ]},
        ],
      },
    },
  },
  {
    id: "pkg-2d1n-sg",
    price_from: 1755000,
    price_original: 2130000,
    discount_percent: 18,
    departure_from: "Singapore",
    image_url: "https://images.unsplash.com/photo-1540541338287-41700207dee6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: GALLERY,
    order: 3,
    t: {
      id: {
        title: "Batam 2D1N – Leisure Escape",
        subtitle: "From Singapore",
        duration: "2D1N",
        badge: "Paling Laris",
        description: "Paket favorit dari Singapore — 2 hari 1 malam di Batam tanpa drama. Cocok untuk couple, keluarga kecil, atau group teman. Sudah termasuk ferry PP, hotel, 2 lunch, beach club, dan semua transport private.",
        inclusions: [
          "Ferry PP Singapore – Batam (HarbourFront ↔ Batam Centre)",
          "Coach private AC selama 2 hari",
          "1 malam hotel bintang 3 di Nagoya area",
          "1× Breakfast hotel + 2× Lunch (Indonesia/Seafood/Chinese)",
          "Pink Beach Club + Tiffany Sand Club",
          "Barelang Bridge & Buddha Temple",
          "Coffee factory + Kueh Lapis tasting",
          "Driver/guide bilingual EN/中文",
        ],
        itinerary: [
          { day: 1, title: "Singapore → Batam · Beach Day", activities: [
            "07:00 – Berkumpul di HarbourFront Ferry Terminal",
            "08:00 – Ferry menuju Batam Centre",
            "09:30 – Pickup & welcome coffee",
            "11:00 – Pink Beach Club + welcome drink",
            "13:00 – Lunch seafood",
            "15:00 – Tiffany Sand Club + sunset",
            "18:00 – Check-in hotel Nagoya",
            "19:30 – Dinner free & explore Nagoya Hills",
          ]},
          { day: 2, title: "City Highlights & Shopping", activities: [
            "07:00 – Breakfast di hotel",
            "09:00 – Check-out & menuju Vihara Maitreya",
            "10:30 – Barelang Bridge photo stop",
            "12:30 – Lunch Indonesia di Sei Enam",
            "14:00 – Coffee factory + tasting Kueh Lapis",
            "15:30 – Shopping batik & oleh-oleh",
            "17:00 – Drop-off Batam Centre",
            "18:30 – Ferry kembali ke Singapore",
          ]},
        ],
      },
      en: {
        title: "Batam 2D1N – Leisure Escape",
        subtitle: "From Singapore",
        duration: "2D1N",
        badge: "Best Seller",
        description: "Our most popular package from Singapore — two days and one night in Batam, hassle-free. Great for couples, small families, or groups of friends. Includes return ferry, hotel, 2 lunches, beach clubs, and all private transport.",
        inclusions: [
          "Return ferry Singapore – Batam (HarbourFront ↔ Batam Centre)",
          "Private AC coach for 2 days",
          "1 night at a 3-star hotel in Nagoya",
          "1× Hotel breakfast + 2× Lunch (Indonesian/seafood/Chinese)",
          "Pink Beach Club + Tiffany Sand Club",
          "Barelang Bridge & Buddha Temple",
          "Coffee factory + Kueh Lapis tasting",
          "Bilingual EN/Chinese driver-guide",
        ],
        itinerary: [
          { day: 1, title: "Singapore → Batam · Beach Day", activities: [
            "07:00 – Meet at HarbourFront Ferry Terminal",
            "08:00 – Ferry to Batam Centre",
            "09:30 – Pickup & welcome coffee",
            "11:00 – Pink Beach Club + welcome drink",
            "13:00 – Seafood lunch",
            "15:00 – Tiffany Sand Club + sunset",
            "18:00 – Hotel check-in in Nagoya",
            "19:30 – Free dinner & explore Nagoya Hills",
          ]},
          { day: 2, title: "City Highlights & Shopping", activities: [
            "07:00 – Breakfast at the hotel",
            "09:00 – Check-out & head to Maitreya Temple",
            "10:30 – Barelang Bridge photo stop",
            "12:30 – Indonesian lunch at Sei Enam",
            "14:00 – Coffee factory + Kueh Lapis tasting",
            "15:30 – Batik & souvenir shopping",
            "17:00 – Drop-off at Batam Centre",
            "18:30 – Ferry back to Singapore",
          ]},
        ],
      },
      zh: {
        title: "巴淡岛2天1夜 – Leisure Escape",
        subtitle: "从新加坡出发",
        duration: "2天1夜",
        badge: "最热门",
        description: "从新加坡出发的人气套餐——两天一夜轻松畅游巴淡岛。适合情侣、小家庭或朋友团。含往返渡轮、酒店、两次午餐、海滩俱乐部及全程私人交通。",
        inclusions: [
          "新加坡－巴淡岛往返渡轮（HarbourFront ↔ Batam Centre）",
          "两天私人空调巴士",
          "Nagoya 区三星级酒店住宿一晚",
          "1× 酒店早餐 + 2× 午餐（印尼／海鲜／中式）",
          "Pink Beach Club + Tiffany Sand Club",
          "巴淡大桥与佛寺",
          "咖啡工厂 + 千层糕试吃",
          "中英双语司机兼导游",
        ],
        itinerary: [
          { day: 1, title: "新加坡 → 巴淡岛 · 海滩日", activities: [
            "07:00 – 于 HarbourFront 渡轮码头集合",
            "08:00 – 乘渡轮前往 Batam Centre",
            "09:30 – 接送与迎宾咖啡",
            "11:00 – Pink Beach Club + 迎宾饮料",
            "13:00 – 海鲜午餐",
            "15:00 – Tiffany Sand Club 与日落",
            "18:00 – 入住 Nagoya 区酒店",
            "19:30 – 自由晚餐，畅游 Nagoya Hills",
          ]},
          { day: 2, title: "城市精华与购物", activities: [
            "07:00 – 酒店早餐",
            "09:00 – 退房前往弥勒佛寺",
            "10:30 – 巴淡大桥拍照停留",
            "12:30 – 于 Sei Enam 享用印尼午餐",
            "14:00 – 咖啡工厂 + 千层糕试吃",
            "15:30 – 选购蜡染与手信",
            "17:00 – 送返 Batam Centre",
            "18:30 – 乘渡轮返回新加坡",
          ]},
        ],
      },
    },
  },
  {
    id: "pkg-3d2n-my",
    price_from: 2260000,
    price_original: 2510000,
    discount_percent: 10,
    departure_from: "Malaysia",
    image_url: "https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: GALLERY,
    order: 4,
    t: {
      id: {
        title: "Batam 3D2N – Golden Promo",
        subtitle: "From Malaysia",
        duration: "3D2N",
        badge: "4★ Hotel",
        description: "Paket Golden 3 hari 2 malam dari Malaysia, menginap di Golden View Hotel 4★ di tepi laut. Includes beach club, theme park pilihan (Dino Gates / Oasis Waterpark), dan tur kuliner lengkap.",
        inclusions: [
          "Ferry PP Malaysia – Batam",
          "2 malam Golden View Hotel 4★ (twin sharing)",
          "2× Breakfast hotel + 2× Lunch",
          "Pink Beach Club + Tiffany Beach Club (free drink)",
          "Pilih: Dino Gates ATAU Oasis Waterpark (1 tiket)",
          "Coffee factory + Kueh Lapis tasting",
          "Batik shopping & oleh-oleh tour",
          "Driver/guide bilingual EN/中文/BM",
        ],
        itinerary: [
          { day: 1, title: "Malaysia → Batam · Beach & Sunset", activities: [
            "08:00 – Berkumpul di Stulang Laut",
            "09:30 – Ferry menuju Batam Centre",
            "11:00 – Welcome coffee + Pink Beach Club",
            "13:00 – Lunch seafood",
            "15:00 – Tiffany Sand Club + sunset",
            "18:00 – Check-in Golden View Hotel 4★",
            "19:30 – Dinner free & explore",
          ]},
          { day: 2, title: "Theme Park & Heritage", activities: [
            "07:00 – Breakfast hotel",
            "09:00 – Dino Gates ATAU Oasis Waterpark (pilih 1)",
            "13:00 – Lunch Chinese / Indonesia",
            "15:00 – Vihara Maitreya & Cheng Ho Mosque",
            "17:00 – Barelang Bridge sunset",
            "19:00 – Dinner free di Nagoya Hills",
          ]},
          { day: 3, title: "Shopping & Pulang", activities: [
            "07:00 – Breakfast hotel",
            "09:00 – Check-out + coffee factory + tasting",
            "11:00 – Shopping batik & oleh-oleh",
            "12:30 – Lunch closing",
            "14:00 – Drop-off Batam Centre",
            "15:30 – Ferry kembali ke Malaysia",
          ]},
        ],
      },
      en: {
        title: "Batam 3D2N – Golden Promo",
        subtitle: "From Malaysia",
        duration: "3D2N",
        badge: "4★ Hotel",
        description: "A three-day, two-night Golden package from Malaysia, staying at the seafront Golden View Hotel 4★. Includes beach clubs, your choice of theme park (Dino Gates / Oasis Waterpark), and a full culinary tour.",
        inclusions: [
          "Return ferry Malaysia – Batam",
          "2 nights at Golden View Hotel 4★ (twin sharing)",
          "2× Hotel breakfast + 2× Lunch",
          "Pink Beach Club + Tiffany Beach Club (free drink)",
          "Choose: Dino Gates OR Oasis Waterpark (1 ticket)",
          "Coffee factory + Kueh Lapis tasting",
          "Batik shopping & souvenir tour",
          "Bilingual EN/Chinese/Malay driver-guide",
        ],
        itinerary: [
          { day: 1, title: "Malaysia → Batam · Beach & Sunset", activities: [
            "08:00 – Meet at Stulang Laut",
            "09:30 – Ferry to Batam Centre",
            "11:00 – Welcome coffee + Pink Beach Club",
            "13:00 – Seafood lunch",
            "15:00 – Tiffany Sand Club + sunset",
            "18:00 – Check-in at Golden View Hotel 4★",
            "19:30 – Free dinner & explore",
          ]},
          { day: 2, title: "Theme Park & Heritage", activities: [
            "07:00 – Hotel breakfast",
            "09:00 – Dino Gates OR Oasis Waterpark (choose 1)",
            "13:00 – Chinese / Indonesian lunch",
            "15:00 – Maitreya Temple & Cheng Ho Mosque",
            "17:00 – Sunset at Barelang Bridge",
            "19:00 – Free dinner at Nagoya Hills",
          ]},
          { day: 3, title: "Shopping & Departure", activities: [
            "07:00 – Hotel breakfast",
            "09:00 – Check-out + coffee factory + tasting",
            "11:00 – Batik & souvenir shopping",
            "12:30 – Farewell lunch",
            "14:00 – Drop-off at Batam Centre",
            "15:30 – Ferry back to Malaysia",
          ]},
        ],
      },
      zh: {
        title: "巴淡岛3天2夜 – Golden Promo",
        subtitle: "从马来西亚出发",
        duration: "3天2夜",
        badge: "四星酒店",
        description: "从马来西亚出发的三天两夜 Golden 套餐，入住海边 Golden View 四星酒店。含海滩俱乐部、主题乐园二选一（Dino Gates／Oasis Waterpark）及完整美食之旅。",
        inclusions: [
          "马来西亚－巴淡岛往返渡轮",
          "Golden View 四星酒店住宿两晚（双人间）",
          "2× 酒店早餐 + 2× 午餐",
          "Pink Beach Club + Tiffany Beach Club（免费饮料）",
          "二选一：Dino Gates 或 Oasis Waterpark（1张门票）",
          "咖啡工厂 + 千层糕试吃",
          "蜡染购物与手信之旅",
          "中英马三语司机兼导游",
        ],
        itinerary: [
          { day: 1, title: "马来西亚 → 巴淡岛 · 海滩与日落", activities: [
            "08:00 – 于 Stulang Laut 集合",
            "09:30 – 乘渡轮前往 Batam Centre",
            "11:00 – 迎宾咖啡 + Pink Beach Club",
            "13:00 – 海鲜午餐",
            "15:00 – Tiffany Sand Club 与日落",
            "18:00 – 入住 Golden View 四星酒店",
            "19:30 – 自由晚餐与自由活动",
          ]},
          { day: 2, title: "主题乐园与人文古迹", activities: [
            "07:00 – 酒店早餐",
            "09:00 – Dino Gates 或 Oasis Waterpark（二选一）",
            "13:00 – 中式／印尼午餐",
            "15:00 – 弥勒佛寺与郑和清真寺",
            "17:00 – 巴淡大桥日落",
            "19:00 – 于 Nagoya Hills 自由晚餐",
          ]},
          { day: 3, title: "购物与返程", activities: [
            "07:00 – 酒店早餐",
            "09:00 – 退房 + 咖啡工厂 + 试吃",
            "11:00 – 选购蜡染与手信",
            "12:30 – 告别午餐",
            "14:00 – 送返 Batam Centre",
            "15:30 – 乘渡轮返回马来西亚",
          ]},
        ],
      },
    },
  },
  {
    id: "pkg-3d2n-sg",
    price_from: 2400000,
    price_original: 2650000,
    discount_percent: 9,
    departure_from: "Singapore",
    image_url: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    gallery: GALLERY,
    order: 5,
    t: {
      id: {
        title: "Batam 3D2N – Golden Promo",
        subtitle: "From Singapore",
        duration: "3D2N",
        badge: "Premium",
        description: "Versi premium 3 hari 2 malam dari Singapore. Menginap di Golden View Hotel 4★ tepi laut, lengkap dengan dua beach club, theme park pilihan, dan tur heritage Batam yang ikonik.",
        inclusions: [
          "Ferry PP Singapore – Batam (HarbourFront ↔ Batam Centre)",
          "2 malam Golden View Hotel 4★ (twin sharing)",
          "2× Breakfast hotel + 2× Lunch",
          "Pink Beach Club + Tiffany Sand Club (free drink)",
          "Pilih: Dino Gates ATAU Oasis Waterpark (1 tiket)",
          "Vihara Maitreya, Barelang Bridge, Cheng Ho Mosque",
          "Coffee factory + Kueh Lapis tasting + batik shopping",
          "Driver/guide bilingual EN/中文",
        ],
        itinerary: [
          { day: 1, title: "Singapore → Batam · Beach Welcome", activities: [
            "07:00 – Berkumpul HarbourFront",
            "08:00 – Ferry menuju Batam Centre",
            "09:30 – Pickup & welcome coffee",
            "11:00 – Pink Beach Club + welcome drink",
            "13:00 – Lunch seafood",
            "15:00 – Tiffany Sand Club + sunset",
            "18:00 – Check-in Golden View Hotel 4★",
          ]},
          { day: 2, title: "Theme Park & Heritage", activities: [
            "07:00 – Breakfast hotel",
            "09:00 – Dino Gates ATAU Oasis Waterpark",
            "13:00 – Lunch Indonesia",
            "15:00 – Vihara Maitreya (kuil terbesar SEA)",
            "17:00 – Barelang Bridge sunset & photo session",
            "19:00 – Dinner free di Nagoya Hills",
          ]},
          { day: 3, title: "Heritage Closing & Pulang", activities: [
            "07:00 – Breakfast hotel",
            "09:00 – Check-out + Cheng Ho Mosque",
            "10:30 – Coffee factory + Kueh Lapis tasting",
            "12:00 – Lunch closing",
            "13:30 – Shopping batik & oleh-oleh",
            "15:30 – Drop-off Batam Centre",
            "17:00 – Ferry kembali ke Singapore",
          ]},
        ],
      },
      en: {
        title: "Batam 3D2N – Golden Promo",
        subtitle: "From Singapore",
        duration: "3D2N",
        badge: "Premium",
        description: "The premium three-day, two-night version from Singapore. Stay at the seafront Golden View Hotel 4★, with two beach clubs, your choice of theme park, and Batam's iconic heritage tour.",
        inclusions: [
          "Return ferry Singapore – Batam (HarbourFront ↔ Batam Centre)",
          "2 nights at Golden View Hotel 4★ (twin sharing)",
          "2× Hotel breakfast + 2× Lunch",
          "Pink Beach Club + Tiffany Sand Club (free drink)",
          "Choose: Dino Gates OR Oasis Waterpark (1 ticket)",
          "Maitreya Temple, Barelang Bridge, Cheng Ho Mosque",
          "Coffee factory + Kueh Lapis tasting + batik shopping",
          "Bilingual EN/Chinese driver-guide",
        ],
        itinerary: [
          { day: 1, title: "Singapore → Batam · Beach Welcome", activities: [
            "07:00 – Meet at HarbourFront",
            "08:00 – Ferry to Batam Centre",
            "09:30 – Pickup & welcome coffee",
            "11:00 – Pink Beach Club + welcome drink",
            "13:00 – Seafood lunch",
            "15:00 – Tiffany Sand Club + sunset",
            "18:00 – Check-in at Golden View Hotel 4★",
          ]},
          { day: 2, title: "Theme Park & Heritage", activities: [
            "07:00 – Hotel breakfast",
            "09:00 – Dino Gates OR Oasis Waterpark",
            "13:00 – Indonesian lunch",
            "15:00 – Maitreya Temple (largest in Southeast Asia)",
            "17:00 – Barelang Bridge sunset & photo session",
            "19:00 – Free dinner at Nagoya Hills",
          ]},
          { day: 3, title: "Heritage Finale & Departure", activities: [
            "07:00 – Hotel breakfast",
            "09:00 – Check-out + Cheng Ho Mosque",
            "10:30 – Coffee factory + Kueh Lapis tasting",
            "12:00 – Farewell lunch",
            "13:30 – Batik & souvenir shopping",
            "15:30 – Drop-off at Batam Centre",
            "17:00 – Ferry back to Singapore",
          ]},
        ],
      },
      zh: {
        title: "巴淡岛3天2夜 – Golden Promo",
        subtitle: "从新加坡出发",
        duration: "3天2夜",
        badge: "尊享",
        description: "从新加坡出发的三天两夜尊享版。入住海边 Golden View 四星酒店，含两大海滩俱乐部、主题乐园二选一，以及巴淡岛经典人文之旅。",
        inclusions: [
          "新加坡－巴淡岛往返渡轮（HarbourFront ↔ Batam Centre）",
          "Golden View 四星酒店住宿两晚（双人间）",
          "2× 酒店早餐 + 2× 午餐",
          "Pink Beach Club + Tiffany Sand Club（免费饮料）",
          "二选一：Dino Gates 或 Oasis Waterpark（1张门票）",
          "弥勒佛寺、巴淡大桥、郑和清真寺",
          "咖啡工厂 + 千层糕试吃 + 蜡染购物",
          "中英双语司机兼导游",
        ],
        itinerary: [
          { day: 1, title: "新加坡 → 巴淡岛 · 海滩迎宾", activities: [
            "07:00 – 于 HarbourFront 集合",
            "08:00 – 乘渡轮前往 Batam Centre",
            "09:30 – 接送与迎宾咖啡",
            "11:00 – Pink Beach Club + 迎宾饮料",
            "13:00 – 海鲜午餐",
            "15:00 – Tiffany Sand Club 与日落",
            "18:00 – 入住 Golden View 四星酒店",
          ]},
          { day: 2, title: "主题乐园与人文古迹", activities: [
            "07:00 – 酒店早餐",
            "09:00 – Dino Gates 或 Oasis Waterpark",
            "13:00 – 印尼午餐",
            "15:00 – 弥勒佛寺（东南亚最大）",
            "17:00 – 巴淡大桥日落与拍照",
            "19:00 – 于 Nagoya Hills 自由晚餐",
          ]},
          { day: 3, title: "人文收尾与返程", activities: [
            "07:00 – 酒店早餐",
            "09:00 – 退房 + 郑和清真寺",
            "10:30 – 咖啡工厂 + 千层糕试吃",
            "12:00 – 告别午餐",
            "13:30 – 选购蜡染与手信",
            "15:30 – 送返 Batam Centre",
            "17:00 – 乘渡轮返回新加坡",
          ]},
        ],
      },
    },
  },
];

const BRANDING = {
  logo_url: null,
  email: "ceotravel88@gmail.com",
  phone: "+62 813 9997 828",
  address: "Ruko Lotus Garden Blok AA No. 10, Batam Center, Kepulauan Riau",
};

// Ratakan paket sesuai bahasa yang diminta (fallback ke Indonesia)
const flatten = (p, lang) => {
  const tr = p.t[lang] || p.t.id;
  return {
    id: p.id,
    price_from: p.price_from,
    price_original: p.price_original,
    discount_percent: p.discount_percent,
    departure_from: p.departure_from,
    image_url: p.image_url,
    gallery: p.gallery,
    order: p.order,
    title: tr.title,
    subtitle: tr.subtitle,
    duration: tr.duration,
    badge: tr.badge,
    description: tr.description,
    inclusions: tr.inclusions,
    itinerary: tr.itinerary,
    exclusions: EXCLUSIONS[lang] || EXCLUSIONS.id,
  };
};

// ---- Fake axios-like client. Resolves data locally, never hits a network. ----
const ok = (data) => Promise.resolve({ data, status: 200, statusText: "OK" });

const handleGet = (url) => {
  const raw = url || "";
  const [pathRaw, queryRaw] = raw.split("?");
  const path = pathRaw.replace(/\/+$/, "");
  const params = new URLSearchParams(queryRaw || "");
  const lang = params.get("lang") || "id";

  if (path === "/packages" || path === "/packages/") {
    const list = [...PACKAGES].sort((a, b) => a.order - b.order).map((p) => flatten(p, lang));
    return ok(list);
  }
  if (path === "/settings/branding") return ok(BRANDING);
  if (path === "/" || path === "") return ok({ message: "CEO Travel API (static)" });
  if (path === "/contacts" || path === "/leads" || path === "/bookings") return ok([]);
  return ok(null);
};

const handlePost = (url, body) => {
  const id = `local-${Date.now()}`;
  return ok({ id, ...(body || {}), created_at: new Date().toISOString() });
};

export const api = {
  get: (url) => handleGet(url),
  post: (url, body) => handlePost(url, body),
  put: (url, body) => ok({ ...(body || {}) }),
  delete: () => ok({ ok: true }),
};

export const API = "/api";
export const WA_PHONE = "628139997828"; // +62 813-9997-828
export const buildWaLink = (msg) => `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(msg)}`;
